import { FC, HTMLAttributes } from 'react';

export const ReactComponent: FC<HTMLAttributes<SVGElement>> = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 16C17 16.5523 16.5523 17 16 17H4C3.44772 17 3 16.5523 3 16V7H17V16ZM5.5 14C5.22386 14 5 14.2239 5 14.5C5 14.7761 5.22386 15 5.5 15H10.5C10.7761 15 11 14.7761 11 14.5C11 14.2239 10.7761 14 10.5 14H5.5ZM5.5 12C5.22386 12 5 12.2239 5 12.5C5 12.7761 5.22386 13 5.5 13H14.5C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12H5.5ZM5.5 10C5.22386 10 5 10.2239 5 10.5C5 10.7761 5.22386 11 5.5 11H14.5C14.7761 11 15 10.7761 15 10.5C15 10.2239 14.7761 10 14.5 10H5.5ZM14 2C14.5523 2 15 2.44772 15 3H16C16.5523 3 17 3.44772 17 4V6H3V4C3 3.44772 3.44772 3 4 3H5C5 2.44772 5.44772 2 6 2C6.55228 2 7 2.44772 7 3H13C13 2.44772 13.4477 2 14 2Z"
      fill="#F2994A"
    />
  </svg>
);
